export function renderBuildRowActionsSourceClientModuleTemplate({
  dialogComponentName,
  dialogModuleName,
  componentName,
  escapeTemplateText,
  escapeJsx
}: {
  dialogComponentName: string
  dialogModuleName: string
  componentName: string
  escapeTemplateText: string
  escapeJsx: string
}): string {
  return `'use client'

import { Button } from '@admin/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger
} from '@admin/components/ui/dropdown-menu'
import { MoreHorizontal } from 'lucide-react'
import * as React from 'react'
import { ${dialogComponentName} } from './${dialogModuleName}'

export function ${componentName}({ id }: { id: string }) {
  const [menuOpen, setMenuOpen] = React.useState(false)
  const [deleteOpen, setDeleteOpen] = React.useState(false)

  function handleDeleteOpenChange(open: boolean) {
    setDeleteOpen(open)

    if (!open) {
      setMenuOpen(false)
    }
  }

  return (
    <DropdownMenu open={menuOpen} onOpenChange={setMenuOpen}>
      <DropdownMenuTrigger
        render={
          <Button
            variant="ghost"
            className="size-8 p-0"
            aria-label={\`Open ${escapeTemplateText} actions for \${id}\`}
          >
            <span className="sr-only">Open ${escapeJsx} actions</span>
            <MoreHorizontal className="size-4" />
          </Button>
        }
      />
      <DropdownMenuContent align="end">
        <${dialogComponentName}
          id={id}
          open={deleteOpen}
          onOpenChange={handleDeleteOpenChange}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
`
}
